import { getLocalStorage, setLocalStorage } from '@/utils/local-storage'

/** Valid view mode values. */
export type ViewMode = 'tiles' | 'list'

const VIEW_MODE_KEY = 'goto-gallery:viewMode'
const DEFAULT_VIEW_MODE: ViewMode = 'tiles'

/**
 * Reads the persisted view mode from `localStorage`.
 *
 * Falls back to `'tiles'` when no value is stored or when the stored value is
 * not a recognised {@link ViewMode}.
 *
 * @returns The current view mode.
 */
export function getViewMode(): ViewMode {
  const stored = getLocalStorage<string>(VIEW_MODE_KEY)
  if (stored === 'tiles' || stored === 'list') {
    return stored
  }
  return DEFAULT_VIEW_MODE
}

/**
 * Persists the selected view mode to `localStorage`.
 *
 * @param mode - The view mode to save.
 */
export function setViewMode(mode: ViewMode): void {
  setLocalStorage(VIEW_MODE_KEY, mode)
}
